import { ExtensionDefinition } from "@backstage/frontend-plugin-api";
import { EntityContentBlueprint } from "@backstage/plugin-catalog-react/alpha";

/**
 * Template usage statistics entity content tab ("Insights").
 *
 * Renders usage summary, monthly stats, and task run cards for
 * `kind:Template` entities. Wraps the three individual components from
 * `@codeverse-gp/plugin-usage-statistics` into a single "Insights" tab,
 * matching the legacy `EntityLayout.Route path="/usage-statistics"` layout.
 *
 * The loader uses a dynamic import of TemplateInsightsTabContent.tsx to keep
 * usage-statistics components out of the main bundle -- they are only
 * downloaded when the Insights tab is first opened (code splitting).
 */
export const templateInsightsContent: ExtensionDefinition =
    EntityContentBlueprint.make({
        name: "template-insights",
        params: {
            path: "/usage-statistics",
            title: "Insights",
            filter: "kind:Template",
            loader: async () => {
                const { TemplateInsightsTabContent } = await import(
                    "./TemplateInsightsTabContent"
                );
                return <TemplateInsightsTabContent />;
            },
        },
    });
